import {Injectable} from '@angular/core';
import swal, { SweetAlertType } from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    constructor() {
    }

    question(titulo: string, mensagem: string, callbackConfirm?) {
        swal({
            title: titulo,
            text: mensagem,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) callbackConfirm();
        });
    }

    async confirm(mensagem: string): Promise<boolean> {
        const result = await swal({
            title: 'Confirmação',
            text: mensagem,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        });
        return result.value === true;
    }

    message(titulo: string, mensagem: string) {
        swal({
            title: titulo,
            text: mensagem,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Voltar',
        }).catch(swal.noop);
    }

    questionV2(title: string, text: string, type: SweetAlertType, callbackConfirm?) {
        swal({
            title,
            text,
            type,     
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) callbackConfirm();
        });
    }

    async messageV2(title: string, text: string, type: SweetAlertType): Promise<void> {
        swal({
            title,
            text,
            type,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Fechar',
        }).catch(swal.noop);
    }
}
